/* eslint-disable react/prop-types */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { connect } from 'react-redux';
import DollarOutput from '../utils/DollarOutput';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../infrastructure/utils/common';
import PartyOrdersListMobile from './PartyOrdersList/PartyOrdersListMobile';

class EventOrdersList extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnClick } = this.props;
    handleOnClick(event.currentTarget.getAttribute('href'));
  };

  getEventDate = order => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { party } = this.props;
    return `${moment(order.startDateTime)
      .tz(party.tz)
      .format('MM/DD/YY hh:mm A ')} - ${moment(order.endDateTime)
      .tz(party.tz)
      .format('MM/DD/YY hh:mm A ')}`;
  };

  getOrderPlacedDate = order => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { party } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    return moment(order.created).tz(party.tz).format('MM/DD/YY hh:mm A z');
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { orders, party } = this.props;

    if (isMobileResolution()) {
      return (
        <PartyOrdersListMobile
          orders={orders}
          getEventDate={this.getEventDate}
          getOrderPlacedDate={this.getOrderPlacedDate}
          onOrderClick={this.handleOnClick}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          party={party}
        />
      );
    }

    return (
      <div className='orderslist'>
        <h2 className='header'>Orders</h2>
        <Table hover>
          <thead>
            <tr>
              <th>BACH Confirmation Code</th>
              <th>Event Dates</th>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <th name='totalPrice' className='sortColumn'>
                  Price
                </th>
              }
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <th name='status' className='sortColumn'>
                  Status
                </th>
              }
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <th name='created' className='sortColumn'>
                  Order Placed Date (Central Time){' '}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {orders.map(order => (
              <tr
                key={order.id}
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                href={`/orders/${order.id}`}
                className='listrow'
                onClick={this.handleOnClick}
              >
                <td style={{ verticalAlign: 'middle' }}>
                  {order.bachConfirmation}
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  {this.getEventDate(order)}
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  <DollarOutput value={order.totalPrice} />
                </td>
                <td style={{ verticalAlign: 'middle' }}>{order.status}</td>
                <td style={{ verticalAlign: 'middle' }}>
                  {this.getOrderPlacedDate(order)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    shopify: state.shopify.shopifyLinks,
  };
}

export default connect(mapStateToProps)(EventOrdersList);
